import React from 'react'

const About = () => {
  return (
    <div name="About" 
    className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white flex justify-center">
      <div className="max-w-screen-lg p-4 max-auto flex flex-col justify-center w-full h-full">
          <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              About
            </p>
          </div>
          <p className="text-xl mt-20">
          Welcome! Are you seeking a seasoned Website Developer and Designer for your digital endeavors? Look no further – Website Design Wala is at your service! With a wealth of experience, I specialize in crafting captivating user experiences through UX design portfolios, customized WordPress themes, and content optimization.

          In addition to my prowess in frontend development, encompassing CSS3, HTML5, JavaScript, and Tailwind CSS, I possess a keen understanding of digital marketing principles. My expertise extends to designing and developing various websites, including those for digital marketing, travel and tours, personal portfolios, medical companies, e-commerce stores, and real estate ventures.
          </p>
          <br />
          <p className="text-xl">
          My proficiency extends beyond website development – I have a strong command of graphic design tools like Photoshop, Illustrator, and Canva, allowing me to create visually stunning assets. Moreover, I excel in video editing using Camtasia Software and Canva's online tools, enhancing multimedia content to engage audiences effectively.

          As a passionate content creator, I leverage my blogging hobby to empower skilled individuals worldwide. Through insightful articles and engaging videos, I share experiences and ideas, fostering a community of learning and growth.

          Let's collaborate to elevate your digital presence and bring your vision to life with creativity and precision.
          </p>
      </div>
    </div>
  )
}

export default About
